import React from "react";
import styled from "styled-components";

const Root = styled.div`
  width: ${props => props.width || "fit-content"};
  border: ${props => props.borderWidth || "2px"} solid
    ${props =>
      props.variant === "outlined" &&
      (props.borderColor || props.theme.colors.primary.white)};
  background-color: ${props => props.bgColor ||
    (props.variant === "contained"
      ? props.theme.colors.primary.green
      : "transparent")};
  padding: ${props => props.padding || "1.6rem"};
  color: ${props => props.color || props.theme.colors.primary.white};
  font-weight: ${props => props.theme.fontWeight.bold};
  font-size: ${props => props.fontSize || "1.8rem"};
  cursor: pointer;
  border-radius: ${props =>
    props.borderRadius || props.shape === "round" ? "32px" : "0"};

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Button = ({ children, onClick, ...restProps }) => {
  return (
    <Root onClick={onClick} {...restProps}>
      {children}
    </Root>
  );
};
